import { createApiClient, type ApiClientOptions } from "../client";
import { createCoreWidgetsApi } from "./widgets.api";
import { createCoreArtistsApi } from "./artists.api";
import { createCoreAlbumsApi } from "./albums.api";
import { createCorePlaylistsApi } from "./playlists.api";
import { createCoreUserPlaylistsApi } from "./user-playlists.api";
import { createCoreSongsApi } from "./songs.api";
import { createCoreVideosApi } from "./videos.api";
import { createCoreCategoriesApi } from "./categories.api";
import { createCoreSearchApi } from "./search.api";
import { createCorePodcastsApi } from "./podcasts.api";
import { createCoreRadioApi } from "./radio.api";
import { createCoreBlogApi } from "./blog.api";
import { createCorePlansApi } from "./plans.api";
import { createCoreAuthApi } from "./auth.api";
import { createCoreContentPagesApi } from "./content-pages.api";
import { createCorePlaybackApi } from "./playback.api";
import { createCoreDiscoverApi } from "./discover.api";
import { createCoreNotificationsApi } from "./notifications.api";
import { createCoreUsersApi } from "./users.api";
import { createCoreSettingsApi } from "./settings.api";

export function createCoreApi(options: ApiClientOptions) {
  const client = createApiClient(options);
  return {
    client,
    widgets: createCoreWidgetsApi(client),
    artists: createCoreArtistsApi(client),
    albums: createCoreAlbumsApi(client),
    playlists: createCorePlaylistsApi(client),
    userPlaylists: createCoreUserPlaylistsApi(client),
    songs: createCoreSongsApi(client),
    videos: createCoreVideosApi(client),
    categories: createCoreCategoriesApi(client),
    search: createCoreSearchApi(client),
    podcasts: createCorePodcastsApi(client),
    radio: createCoreRadioApi(client),
    blog: createCoreBlogApi(client),
    plans: createCorePlansApi(client),
    auth: createCoreAuthApi(client),
    contentPages: createCoreContentPagesApi(client),
    playback: createCorePlaybackApi(client),
    discover: createCoreDiscoverApi(client),
    notifications: createCoreNotificationsApi(client),
    users: createCoreUsersApi(client),
    settings: createCoreSettingsApi(client),
  };
}

export type CoreApi = ReturnType<typeof createCoreApi>;
export * from "./widgets.api";
export * from "./artists.api";
export * from "./albums.api";
export * from "./playlists.api";
export * from "./user-playlists.api";
export * from "./songs.api";
export * from "./videos.api";
export * from "./categories.api";
export * from "./search.api";
export * from "./podcasts.api";
export * from "./radio.api";
export * from "./blog.api";
export * from "./plans.api";
export * from "./auth.api";
export * from "./content-pages.api";
export * from "./playback.api";
export * from "./discover.api";
export * from "./notifications.api";
export * from "./users.api";
export * from "./settings.api";
